import type { AppNotification } from '@digital-twins/shared-types'

function asNonEmptyString(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null
  }

  const trimmed = value.trim()
  return trimmed.length > 0 ? trimmed : null
}

function normalizeLegacyChatHref(href: string): string {
  const match = href.match(/^\/chat\/([^/?#]+)/)
  if (match) {
    return `/chats/${match[1]}`
  }

  return href
}

export function getNotificationHref(notification: AppNotification): string | undefined {
  const { type, href, metadata } = notification
  const studyId = asNonEmptyString(metadata?.studyId)
  const audienceId = asNonEmptyString(metadata?.audienceId)
  const chatId = asNonEmptyString(metadata?.chatId)
  const threadToken = asNonEmptyString(metadata?.threadToken)

  if ((type === 'study_completed' || type === 'study_failed') && studyId) {
    return `/tests/${studyId}/results`
  }

  if ((type === 'audience_ready' || type === 'audience_failed') && audienceId) {
    return `/audiences/${audienceId}`
  }

  if (type === 'audience_shared') {
    const token = asNonEmptyString(metadata?.inviteToken)
    if (token) {
      return `/audiences/invites/${token}/accept`
    }
    if (audienceId) {
      return `/audiences/${audienceId}`
    }
  }

  if (type === 'audience_invite_accepted' && audienceId) {
    return `/audiences/${audienceId}`
  }

  if ((type === 'chat_shared' || type === 'chat_viewed') && chatId) {
    return `/chats/${chatId}`
  }

  if (
    (type === 'workflow_run_completed' || type === 'workflow_run_failed') &&
    threadToken
  ) {
    return `/threads/${threadToken}`
  }

  if (!href) {
    return undefined
  }

  return normalizeLegacyChatHref(href)
}
